<template>
  <div class="imgBox min-w-1400">
    <div class="imgBox1 min-w-1400">
      <div class="img1Box max-w-1400">
        <img :src="importedImg1" alt="" class="imgItem1" />
      </div>
    </div>
  </div>
</template>

<script>
import "./index.css";
import importedImg1 from "@/page/ageventurescompanylimited/components/img/footer.png";

export default {
  data() {
    return {
      importedImg1: importedImg1,
      altText: "图片",
    };
  },
};
</script>

<style scoped>
.imgBox {
  display: flex;
  flex-direction: column;
  background-color: white;
}

img {
  display: block;
}

.imgBox1{
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: "";
}

.img1Box{
  width: 100%;
  overflow: hidden;
  background-color: "";
}

.imgItem1 {
  width: 100%;
  margin: auto;
}

.img1Box {
  position: relative;
  margin-top: -2px;
}
</style>
